import { trpc } from "../../../lib/api/trpc";

export const useDashboardStats = () => {
  const { data, isLoading, isError, error, refetch } =
    trpc.organization.getDashboardStats.useQuery();

  return {
    stats: data as DashboardStats | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export type DashboardStats = {
  documents: {
    total: number;
    indexed: number;
    processing: number;
    failed: number;
  };
  totalIndexedChunks: number;
  queries: {
    last7Days: number;
    last30Days: number;
  };
  unansweredLast30Days: number;
  stuckDocuments: number;
  recentDocuments: Array<{
    id: string;
    filename: string;
    status: string;
    createdAt: string;
    chunkCount: number | null;
  }>;
};
